
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'userPermission',
    pure: false
})
export class UserPermissionPipe implements PipeTransform {
    transform(items: Array<any> = [], filter?: number): Array<any> {
        if (filter === undefined) {
            filter = 1;
        }

        return items.filter((item: any) => {
            return item.AccessId == filter
        });
    }
}